import { Link } from 'react-router-dom';

import ChangePasswordForm from '../../forms/changePasswordForm';

import brand from '../../../assets/images/brand.png';
import motif from '../../../assets/images/motif.png';

import classNames from './auth.module.scss';
import routes from '../../../utils/routes';

const ChangePassword = () => {
	return (
		<div className={classNames.newLogin}>
			<div className={classNames.newLoginInner}>
				<div className={classNames.newLoginLeft}>
					<div className={classNames.newLoginLeftBrand}>
						<Link to={routes.home.pathname}>
							<img src={brand} alt="Arridex Brand" loading="lazy" />
						</Link>
					</div>

					<h3>Create New Password</h3>

					<ChangePasswordForm />
				</div>

				<div className={classNames.newLoginRight}>
					<img src={motif} alt="Motif" loading="lazy" />
				</div>
			</div>
		</div>
	);
};

export default ChangePassword;
